var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinnerSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 13.6861 3.20043 15.2647 3.98703 16.6245C4.19443 16.983 4.07191 17.4418 3.71337 17.6492C3.35482 17.8566 2.89602 17.7341 2.68862 17.3755C1.77351 15.7936 1.25 13.9568 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C13.9568 1.25 15.7936 1.77351 17.3755 2.68862C17.7341 2.89602 17.8566 3.35482 17.6492 3.71337C17.4418 4.07191 16.983 4.19443 16.6245 3.98703C15.2647 3.20043 13.6861 2.75 12 2.75ZM20.2868 6.35121C20.6453 6.14382 21.1041 6.26635 21.3115 6.6249C22.2265 8.20679 22.75 10.0435 22.75 12.0002C22.75 17.9373 17.9371 22.7502 12 22.7502C10.0433 22.7502 8.20657 22.2268 6.62468 21.3117C6.26613 21.1043 6.14359 20.6455 6.35099 20.287C6.55839 19.9284 7.01718 19.8059 7.37573 20.0133C8.73548 20.7998 10.314 21.2502 12 21.2502C17.1086 21.2502 21.25 17.1088 21.25 12.0002C21.25 10.3142 20.7996 8.7357 20.0131 7.37596C19.8057 7.01741 19.9282 6.55861 20.2868 6.35121Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerSolid);
export default __webpack_public_path__ + "static/media/spinner-solid.b18961f58769d745366f9038258f854a.svg";
export { ForwardRef as ReactComponent };